import {createAction} from '@ngrx/store';

export const appInit = createAction('[App] init');
export const reset = createAction('[App] reset');
